import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { isExternal } from "@/lib/site";

type Variant = "solid" | "accent" | "outline";

interface Props {
  to: string;
  label: string;
  variant?: Variant;
  size?: "sm" | "md";
  arrow?: boolean;
  className?: string;
  onClick?: () => void;
}

const VARIANTS: Record<Variant, string> = {
  solid: "bg-fg text-bg hover:bg-fg/90",
  accent: "bg-lime text-ink hover:bg-[#d8ff7d]",
  outline: "border border-fg/25 text-fg hover:border-fg/60 hover:bg-fg/5",
};

const SIZES = {
  sm: "px-5 py-2.5 text-sm",
  md: "px-7 py-4 text-[0.9375rem]",
};

/** Pill call-to-action. Internal paths use the router; absolute URLs and mailto links use a plain anchor. */
export function PillLink({ to, label, variant = "solid", size = "md", arrow = false, className = "", onClick }: Props) {
  const classes = `group inline-flex items-center justify-center gap-2.5 rounded-full font-medium tracking-[-0.01em] transition-colors duration-300 ${VARIANTS[variant]} ${SIZES[size]} ${className}`;

  const content = (
    <>
      <span className="roll">
        <span data-text={label}>{label}</span>
      </span>
      {arrow && (
        <ArrowUpRight
          aria-hidden="true"
          className="h-4 w-4 transition-transform duration-500 ease-out-expo group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
        />
      )}
    </>
  );

  if (isExternal(to)) {
    return (
      <a href={to} className={classes} onClick={onClick}>
        {content}
      </a>
    );
  }
  return (
    <Link to={to} className={classes} onClick={onClick}>
      {content}
    </Link>
  );
}
